import { Form, Modal, Typography } from 'antd';
import Button from '../../UI/Button/Button';
import React from 'react';
import Input from '../../UI/Input/Input';
import { useTranslation } from 'react-i18next';

const ForgotPasswordModal = ({
  open,
  onClose,
  onSubmit,
  onChange,
  onHome,
  isValid,
  form
}) => {
  const { t } = useTranslation();
  const [step, setStep] = React.useState('reset');

  const handleSubmit = async() => {
    try {
      await onSubmit();
      setStep('confirm');
    } catch (error) {
      setStep('reset');
    }
  };

  const handleClose = () => {
    setStep('reset');
    onClose();
  };

  const handleHome = () => {
    setStep('reset');
    onHome();
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={handleClose}
    >
      {step === 'reset' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            alignItems: 'center',
            marginTop: 50,
            width: '100%'
          }}
        >
          <h2 style={{ textAlign: 'center' }}>
            {t('modals.forgotPassword.title1')}
          </h2>
          <Typography
            style={{
              marginTop: 20,
              fontSize: 20,
              fontWeight: 400,
              textAlign: 'center'
            }}
          >
            {t('modals.forgotPassword.description1')}
          </Typography>
          <Form
            form={form}
            layout='vertical'
            onFinish={handleSubmit}
            style={{ marginTop: 40, width: '100%' }}
            onFieldsChange={onChange}
          >
            <Form.Item
              name='email'
              rules={[{ required: true, message: t('schema.required') }]}
            >
              <Input size='large' placeholder={t('input.email')} />
            </Form.Item>

            <Button
              wide
              disabled={!isValid}
              onClick={form.submit}
              style={{ marginBottom: 20 }}
            >
              {t('button.reset')}
            </Button>
            <Button wide mode='outlined' onClick={handleHome}>
              {t('button.signIn')}
            </Button>
          </Form>
        </div>
      )}
      {step === 'confirm' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            alignItems: 'center',
            marginTop: 70,
            width: '100%'
          }}
        >
          <h2 style={{ textAlign: 'center' }}>
            {t('modals.forgotPassword.title2')}
          </h2>
          <Typography
            style={{
              marginTop: 20,
              marginBottom: 20,
              fontSize: 20,
              fontWeight: 400,
              textAlign: 'center'
            }}
          >
            {t('modals.forgotPassword.description2')}
          </Typography>
          <Button wide mode='outlined' onClick={handleHome}>
            {t('button.signIn')}
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default ForgotPasswordModal;
